import {Node} from "@xyflow/react";
import {getNodeWidth} from "./FamilyTreeNodeSizing";

export function getNodeHandleX(node: Node, handle: 'left' | 'right' | 'center' = 'center'): number {
    const width = getNodeWidth(node);
    if (handle === 'left') return node.position.x - width / 2;
    if (handle === 'right') return node.position.x + width / 2;
    return node.position.x;
}

export function getNodeHandleY(node: Node): number {
    return node.position.y;
}

export function isOtherMembersSection(node: Node): boolean {
    return node.type === 'otherMembersSection';
}
